import { render, staticRenderFns } from "./ManageComplaints.vue?vue&type=template&id=62c0a6ff"
import script from "./ManageComplaints.vue?vue&type=script&lang=js"
export * from "./ManageComplaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports